<div class="seats-selected-list-container">
  <div class="seat-container flex" *ngFor="let seat of seatsSelected; let i = index; let last = last">
    <div class="row seat-container-header">
      <div class="col">
        {{ 'book-movie-list.person-order' | translateSelector: { count: i + 1 } | uppercase }}
      </div>
    </div>
    <div class="row flex" [ngClass]="{'pb-2': !last}">
      <div class="col-3 col-lg-6">
        <div class="row-head">{{ 'ticketssummary.row' | translate }}</div>
        <div class="row-body">{{ seat.rowSymbol }}</div>
      </div>
      <div class="col-3 col-lg-6">
        <div class="row-head">{{ 'ticketssummary.seat' | translate }}</div>
        <div class="row-body">{{ seat.symbol }}</div>
      </div>
      <div class="col-3 col-lg-6">
        <div class="row-head">{{ 'book-movie-list.amenities' | translate }}</div>
        <div class="row-body">
          {{
            (seat.hasAssignedGroupType('wheelchair')
              ? 'screen.legend.group.wheelchair'
              : seat.hasAssignedGroupType('couch') || seat.hasAssignedGroupType('lounge')
                ? 'screen.legend.group.couch'
                : seat.hasAssignedGroupType('vip')
                  ? 'screen.legend.group.vip'
                  : 'screen.legend.group.none') | translate
          }}
        </div>
      </div>
      <div class="col col-lg-6"></div>
    </div>
  </div>
</div>